import React, { useEffect, useState, useMemo } from "react";
import apiClient from '../utils/apiClient';
import Swal from "sweetalert2";
import { SERVER_BASE } from '../config/server';
import { useTable, usePagination, useGlobalFilter, useSortBy } from "react-table";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faEdit, faTrash, faPlus, faPencil } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';
import Select from 'react-select';
const PurposeInventory = ({ permissions }) => {
  const [purposes, setPurposes] = useState([]);
  const [purposeName, setPurposeName] = useState('');
  const [purposeType, setPurposeType] = useState('');
  const [editIndex, setEditIndex] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedType, setSelectedType] = useState(null);
  const code = localStorage.getItem('code');
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  const email = localStorage.getItem('email');
  const [loadingData, setLoadingData] = useState(true);
  const typeOptions = [
    { value: 'Major Center', label: 'Major Center' },
    { value: 'Only Area Jurisdiction', label: 'Only Area Jurisdiction' },
    { value: 'Both', label: 'Both' },
  ];
  useEffect(() => {
    fetchPurposes();
  }, []);

  const fetchPurposes = async () => {
    try {
      setLoadingData(true)
      const response = await apiClient.get(SERVER_BASE + '/getpurposesInventory', {
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
        params: { code }, // Pass 'code' as a parameter in the request
      });

      setPurposes(response.data);
    } catch (error) {
      console.error('Error fetching purposes:', error);
    } finally {
      setLoadingData(false)
    }
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    if (!purposeName) {
      Swal.fire({
        icon: 'error',
        text: 'Please enter event name',
        toast: true,
        position: 'top-end',
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }
    if (!purposeType) {
      Swal.fire({
        icon: 'error',
        text: 'Please enter event type',
        toast: true,
        position: 'top-end',
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }
    if (!selectedType?.value) {
      Swal.fire({
        icon: 'error',
        text: 'Please select applicable on',
        toast: true,
        position: 'top-end',
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }
    Swal.fire({
      title: editIndex !== null ? 'Confirm Update' : 'Confirm Create',
      text: editIndex !== null ? 'Are you sure you want to update this purpose?' : 'Are you sure you want to create this purpose?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          if (editIndex !== null) {
            await apiClient.put(`${SERVER_BASE}/updatePurposesInventory/${purposes[editIndex].id}`,
              {
                purposeName,
                purposeType,
                code,
                selectedType,
                email
              }, {
              headers: {
                Authorization: `Bearer ${token}`, // Add the JWT token in the header
              }
            });
            fetchPurposes();
            setEditIndex(null);
          } else {
            // Create new purpose
            await apiClient.post(SERVER_BASE + '/addpurposesInventory', {
              purposeName,
              purposeType,
              code,
              selectedType,
              email
            }, {
              headers: { Authorization: `Bearer ${token}` },
            });
            fetchPurposes();
          }

          resetForm();
          Swal.fire(editIndex !== null ? 'Updated!' : 'Created!', `Purpose has been ${editIndex !== null ? 'updated' : 'created'}.`, 'success');
        } catch (error) {
          console.error('Error saving purpose:', error);
          Swal.fire('Error', 'There was an issue saving the purpose. Please try again later.', 'error');
        }
      }
    });
  };

  const resetForm = () => {
    setPurposeName('');
    setPurposeType('');
  };

  const handleEdit = (index) => {
    const purpose = purposes[index];
    setPurposeName(purpose.purposeName); // Assuming 'purpose_name' is the correct field
    setPurposeType(purpose.purposeType);
    setSelectedType({ value: purpose?.applicableOn, label: purpose?.applicableOn })
    setEditIndex(index);
    setShowForm(true);
  };


  const handleDelete = (index) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this purpose!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await apiClient.delete(`${SERVER_BASE}/deletePurposesInventory/${purposes[index].id}`, {
            data: { code },

            headers: {
              Authorization: `Bearer ${token}`, // Add the JWT token in the header
            },
            // Include 'code' in the delete request
          });
          setPurposes((prev) => prev.filter((_, i) => i !== index));
          Swal.fire('Deleted!', 'Your purpose has been deleted.', 'success');
        } catch (error) {
          console.error('Error deleting purpose:', error);
          Swal.fire('Error', 'There was an issue deleting the purpose. Please try again later.', 'error');
        }
      }
    });
  };

  const columns = useMemo(
    () => [
      {
        Header: 'S.No',
        Cell: ({ row }) => row.index + 1,
      },
      { Header: 'Event', accessor: 'purposeName' }, // Assuming the column name is `purpose_name` in the data
      { Header: 'Type', accessor: 'purposeType' },
      { Header: 'Applicable On', accessor: 'applicableOn' }, // Assuming the column name is `purpose_name` in the data
      {
        Header: "#",
        accessor: "Action",
        Cell: ({ row }) => {
          const {
            createdAt,
            createdByName,
            updatedAt,
            updatedByName,
          } = row.original;
          return (
            <div className="dropdown">
              <button
                className="btn btn-sm btn-light"
                type="button"
                id={`dropdownMenuButton-${row.index}`}
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <FontAwesomeIcon icon={faEllipsisV} />
              </button>

              <ul
                className="dropdown-menu"
                aria-labelledby={`dropdownMenuButton-${row.index}`}
              >
                {(role === "itManager" || permissions?.edit) && (
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleEdit(row.index)}
                    >
                      <FontAwesomeIcon icon={faEdit} className="me-2" />
                      Edit
                    </button>
                  </li>
                )}

                {(role === "itManager" || permissions?.delete) && (
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleDelete(row.index)}
                    >
                      <FontAwesomeIcon icon={faTrash} className="me-2" />
                      Delete
                    </button>
                  </li>
                )}
                {(createdByName || updatedByName) && (
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                )}
                {createdByName && (
                  <li className="dropdown-item">
                    <FontAwesomeIcon icon={faPlus} /> {createdByName}
                    {createdAt &&
                      ` (${moment(createdAt).format("DD-MMM-YY hh:mm A")})`}
                  </li>
                )}

                {/* Updated Info */}
                {updatedByName && (
                  <li className="dropdown-item">
                    <FontAwesomeIcon icon={faPencil} /> {updatedByName}
                    {updatedAt &&
                      ` (${moment(updatedAt).format("DD-MMM-YY hh:mm A")})`}
                  </li>
                )}
              </ul>
            </div>
          );
        },
      }
    ],
    [purposes]
  );


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setGlobalFilter,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize, globalFilter },
  } = useTable(
    {
      columns,
      data: purposes,
      initialState: { pageIndex: 0, pageSize: 20 }, // min-20 page size
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  if (loadingData) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '60vh' }}>
        <div className="spinner-border text-success" role="status" style={{ width: '3rem', height: '3rem' }}>
          <span className="visually-hidden">Loading...</span>
        </div>
        <div className="mt-3 fs-5">Please Wait...</div>
      </div>
    );
  }
  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Event Management - Inventory</h3>
        <div className="ledger-count">
          Total Events: <strong>{purposes.length}</strong>
        </div>
      </div>

          {(role == 'itManager' || permissions?.write) && (
            <form onSubmit={handleSubmit} className="formcontainer mb-3">
              <div className="row mb-3 align-items-end">
                <div className="col-md-4">
                  <label htmlFor="purposeName" className="form-label">Event Name</label>
                  <input
                    type="text"
                    id="purposeName"
                    value={purposeName}
                    onChange={(e) => setPurposeName(e.target.value)}
                    className="form-control"
                    required
                  />
                </div>

                <div className="col-md-3">
                  <label>Event Type *</label>
                  <select className="form-select" value={purposeType} onChange={(e) => setPurposeType(e.target.value)}>
                    <option value="">Select Type</option>
                    <option value="Add">Add</option>
                    <option value="Less">Less</option>
                  </select>
                </div>
                <div className="col-md-3">
                  <label htmlFor="typeSelect" className="form-label">Applicable On</label>
                  <Select
                    options={typeOptions}
                    value={selectedType}
                    onChange={setSelectedType}
                    placeholder="Select.."
                  />
                </div>
                <div className="col-md-2">
                  <button type="submit" className="btn btn-outline-success">
                    {editIndex !== null ? 'Update Event' : 'Add Event'}
                  </button>
                </div>
              </div>
            </form>
          )}
      {(role == 'itManager' || permissions?.read) && (
        <div className='formcontainer table-responsive'>
          <div className="d-flex justify-content-between gap-3">
            <input
              className="form-control"
              placeholder="Search"
              value={globalFilter || ""}
              onChange={(e) => setGlobalFilter(e.target.value)}
            />
            <label className="d-inline-flex align-items-center ">
              <select
                value={pageSize}
                onChange={(e) => setPageSize(Number(e.target.value))}
                className="form-select w-auto"
              >
                {[20, 30, 50, 100].map((size) => (
                  <option key={size} value={size}>
                    Show {size}
                  </option>
                ))}
              </select>
            </label>
          </div>
          <table {...getTableProps()} className="table table-striped">
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                      {column.render('Header')}
                      <span>{column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}</span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => (
                      <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>

          <div className="d-flex align-items-center mb-3">
            {/* Previous – left corner */}
            <button
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
              className="btn btn-secondary me-auto"
              style={{ minWidth: 110 }}   // keeps width consistent
            >
              Previous
            </button>

            {/* Center block for page index & size selector */}
            <div className="text-center flex-grow-1 d-flex flex-column align-items-center">
              {/* Row 1: Page index and size selector in one line */}
              <div className="d-flex align-items-center gap-3">
                <div className="fw-semibold">
                  Page {pageIndex + 1} of {pageOptions.length}
                </div>

                <label className="d-inline-flex align-items-center mb-0">
                  Show&nbsp;
                  <select
                    value={pageSize}
                    onChange={(e) => setPageSize(Number(e.target.value))}
                    className="form-select form-select-sm w-auto"
                  >
                    {[20, 30, 50, 100].map((size) => (
                      <option key={size} value={size}>
                        {size}
                      </option>
                    ))}
                  </select>
                  &nbsp;rows
                </label>
              </div>
            </div>


            {/* Next – right corner */}
            <button
              onClick={() => nextPage()}
              disabled={!canNextPage}
              className="btn btn-secondary ms-auto"
              style={{ minWidth: 110 }}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PurposeInventory;
